module.exports = __webpack_public_path__ + "img/admin_adv_03.7cd87984.png";